import Backbone from 'backbone';

import Config from '../../config'
import Model from '../model';





export default Model.extend( {

    endpoint: 'fields', responseAt: 'custom_field',
    
    defaults() {
        return {
            // "id" must be specified here in order
            // to make Epoxy's "toggle:not(id)" binding filter work.
            // (see customField.form.handlebars and "format"
            // field for example).
            id: undefined,
            cluster: null,
            table_id: undefined, multiselect: undefined, allow_add_num: undefined,
            name: '',
            format: 'string',
            group_name: undefined,
            possible_values: [],
            regexp: undefined,
            min_length: undefined,
            max_length: undefined,
            is_required: 'f',
            default_value: undefined,
            visible: 't',
            is_for_all: 'f',
            types: [],
            min_count: 1,
            max_count: 1,
            min_size: undefined,
            max_size: undefined,
            auto_apply_sticker: 'f',
            subfields: [],
            file_types: ['PHOTO'],
            sticker_ids: null, __all_stickers_available: undefined,
        }
    },
    
    computeds: {
        
        // make copy of "regexp" property
        // with start and end "/"
        regexp_: {
            
            set(value) {
                if ('string' !== typeof value)
                    return { regexp: value };
                    
                if ('' === value)
                    return { regexp: '' };
                    
                return { regexp: `/${value}/` };
            },
            
            get() {
                let value = this.get( 'regexp' );
                // "/value/"
                if ('string' === typeof value)
                    // correct for empty string too
                    value = value.substring( 1, value.length - 1 ); 
                return value;
            }
        },
        
        // treat "0" for minlength and maxlength as no value
        min_length_: {
            
            set(value) {
                if ('' === value)
                    return { min_length: 0 };
                return { min_length: value }; 
            },
            
            get() {
                let value = this.get( 'min_length' );
                if ('0' === value)
                    return undefined; 
                if (0 === value) 
                    return undefined;
                    
                return value;
            }
            
        },

        // treat "0" for minlength and maxlength as no value
        max_length_: {
            
            set(value) {
                if ('' === value)
                    return { max_length: 0 };
                return { max_length: value }; 
            },
            
            get() {
                let value = this.get( 'max_length' );
                if ('0' === value)
                    return undefined; 
                if (0 === value) 
                    return undefined;
                    
                return value;
            }
            
        },
        
        
        // treat list of strings as string with "\n"s
        // at UI level
        possible_values_: {

            set(value) {
                const newPossibleValues = value.split( '\n' );

                const defaultValue = this.get( 'default_value' );
                if (!defaultValue)
                    return { possible_values: newPossibleValues }; 

                // default value hasn't changed in possible values list
                if (~newPossibleValues.indexOf( defaultValue ))
                    return { possible_values: newPossibleValues }; 

                const oldPossibleValues = this.get( 'possible_values' ) || [];
                if (newPossibleValues.length !== oldPossibleValues.length) 
                    return { possible_values: newPossibleValues, default_value: '' }; 
                
                const oldDefaultValueIndex = oldPossibleValues.indexOf( defaultValue );
                if (oldDefaultValueIndex < 0)
                    return { possible_values: newPossibleValues, default_value: '' }; 

                const changedItems = newPossibleValues
                    .filter( (value, index ) => value !== oldPossibleValues[index] );
                // no changes or more than one row has been changed:
                // cannot find match for old default value in changed rows
                if (!changedItems.length || changedItems.length > 1)
                    return { possible_values: newPossibleValues, default_value: '' }; 

                // * lengths are equal
                // * one change 
                // * defval is in old list
                // * defval is not in new list
                // -> take new list in position of change
                return { possible_values: newPossibleValues, default_value: changedItems[0] }; 
            },
            
            get() {
                let value = this.get( 'possible_values' );
                if (value instanceof Array)
                    value = value.join( '\n' );
                    
                return value;
            }
            
        },

        default_datetime: {

            set(value) {
                if (this.get( 'format') !== 'date')
                    return {};

                return { default_value: value };
            },

            get() {
                if (this.get( 'format') !== 'date')
                    return null;

                const value = this.get( 'default_value' );
                if (!value)
                    return null;

                return value;
            }

        },

        default_possible_value: {

            set(value) {
                return { default_value: value };
            },

            get() {
                return {
                    selected: this.get( 'default_value' ),
                    options: this.get( 'possible_values' )
                };
            },
        },

    },
    
    customParser(payload) {
        if (payload.subfields instanceof Array)
            payload.subfields = payload.subfields.map( 
                subfieldPayload => this.customParser( subfieldPayload ) );

        if ('string' === typeof payload.possible_values)
            payload.possible_values = payload.possible_values.split( '\n' );
        if ('' === payload.regexp)
            payload.regexp = undefined;
        if (payload.order)
            payload.order = +payload.order;

        const { news_type_ids } = payload;
            
        return {
            ...payload,
            types: news_type_ids,
        };
    },

    clone() {
        const clonify = ({ subfields, ...json }) => ({
            ...json,
            subfields: subfields.map( clonify )
        });

        const Class = this.constructor;
        return new Class( clonify( this.toJSON() ) );
    },

    diff(another, options = {}) {
        const diff = Model.prototype.diff.call( this, another, options )
            .filter( ({ attrName }) => attrName !== 'types');

        const oldTypes = another.get( 'types' );
        const newTypes = this.get( 'types' );

        const originalTypes = oldTypes
            .map( id => +id ).sort();
        const fieldTypes = newTypes
            .map( id => +id ).sort();

        if ('' + originalTypes !== '' + fieldTypes)
            diff.push( {
                attrName: 'types',
                oldValue: oldTypes, newValue: newTypes
            } );

        const oldSubfields = another.get( 'subfields' );
        const newSubfields = this.get( 'subfields' );

        const normalize = array => array
            .sort( ({ order: a }, { order: b }) => a - b )
            // ignore "types" for subfields
            .map( json => Object.keys( json )
                .filter( key => key != 'types' && key != 'new-order' )
                .sort()
                .map( key => [key, json[key]] )
                .map( ([key, value]) => 'subfields' === key
                    ? [key, normalize( [...value] )]
                    : [key, value] )
                .reduce( (hash, [key, value]) => (hash[key] = value, hash), {} ) );

        const originalSubfields = normalize( oldSubfields );
        const fieldSubfields = normalize( newSubfields );

        if (JSON.stringify( originalSubfields ) !== JSON.stringify( fieldSubfields ))
            return diff.push( {
                attrName: 'subfields',
                oldValue: oldSubfields, newValue: newSubfields
            } ), diff;

        return diff;
    },

    suggestionOptions(text) {
        const url = Config.url( `/fields/${this.id}/values?search=${text}` );
        return Backbone.$.ajax( url )
            .then( ({ values }) => values.map( value => value[this.get( 'titleField' )] ) );
    }
    
} );


// WEBPACK FOOTER //
// ./src/js/model/refbooks/field.js